import React, { useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { hasPermission, createHistory, hasAtLeastOnePermission } from '../../sc-utilities';
import DeviceCaseSupportedList from './DeviceCaseSupportedList';
import { FindInPage, AssessmentOutlined } from '@material-ui/icons';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    "@global": {
        "[class*='statusActive']": {
            color: theme.palette.success.dark
        },
        "[class*='statusInactive']": {
            color: theme.palette.error.dark
        }
    },
    statusActive: {
        color: theme.palette.success.dark
    },
    statusInactive: {
        color: theme.palette.error.dark
    }
});

const DeviceCaseSupported = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, deviceCaseSupportedID: null, redirectPath: '' });

    let visible = columns && columns['DeviceCaseSupported'];
    const tableColumns = useMemo(() => {
        return [
            {
                title: translations["actions"] || "Actions", field: 'Actions',
                hidden: visible ? visible['Actions'] : false,
                cellStyle: { minWidth: 100, maxWidth: 100 },
                filtering: false,
                render: rowData => <>
                    {
                        hasPermission(permissions, 'system_device_case_supported_load') ? <Tooltip title={translations["device_case_supported_details"] || "Device case supported details"}>
                            <IconButton value={rowData.DeviceCaseSupportedID} aria-label={translations["device_case_supported_details"] || "Device case supported details"} onClick={() => redirectHandler(`/admin/device-case-supported/update?deviceCaseSupportedID=${rowData.DeviceCaseSupportedID}`, rowData.DeviceCaseSupportedID)}>
                                <FindInPage />
                            </IconButton>
                        </Tooltip> : ''
                    }{
                        <Tooltip title={translations["list_diagnose_cases"] || "List diagnose cases"}>
                            <IconButton value={rowData.DeviceCaseSupportedID} aria-label={translations["list_diagnose_cases"] || "List diagnose cases"} onClick={() => redirectHandler(`/admin/device-case-supported/diagnose?deviceCaseSupportedID=${rowData.DeviceCaseSupportedID}&Name=${rowData.Name}`, rowData.DeviceCaseSupportedID)}>
                                <AssessmentOutlined />
                            </IconButton>
                        </Tooltip>
                    }
                </>
            },
            {
                title: translations["name"] || 'Name', field: 'Name',
                hidden: visible ? visible['Name'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Name ?? (translations['short_not_assigned'] || 'n/a')}</Typography>;
                }
            },
            {
                title: translations["product_type"] || 'Product type', field: 'ProductType',
                hidden: visible ? visible['ProductType'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.ProductType ? translations[rowData.ProductType] || rowData.ProductType : (translations['short_not_assigned'] || 'n/a')}</Typography>;
                }
            },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible])
    if (!hasAtLeastOnePermission(permissions, ['system_device_case_supported_load'])) {
        tableColumns.shift();
    }

    const redirectHandler = (path, deviceCaseSupportedID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, deviceCaseSupportedID: deviceCaseSupportedID, redirectPath: path });
    };

    if (redirectOptions.redirect) {
        return <Redirect
            to={{
                pathname: redirectOptions.redirectPath.split('?')[0], search: redirectOptions.redirectPath.split('?')[1],
                state: { redirectOptions }
            }}
        />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'device_case_supported_list') ?
                <DeviceCaseSupportedList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state?.translate?.translations?.activeTranslations || {},
        columns: state?.core?.login?.userSettings?.Columns || null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(DeviceCaseSupported));